export default __webpack_public_path__ + "static/social-gigaton-e010972ef67ea1d1d9bbb08f8cef3f7d.png";